import { Reveal } from "@/components/Reveal";
import { StripeBar } from "@/components/StripeBar";

export const Chapter = ({ kicker, title, dark = false, className = "" }) => (
  <Reveal className={className}>
    {kicker && (
      <p
        className={`font-mono text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase mb-3 ${
          dark ? "text-gold" : "text-crimson"
        }`}
        data-testid={`section-kicker-${kicker.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      >
        {kicker}
      </p>
    )}
    <h2
      className={`font-display font-extrabold uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-5xl ${
        dark ? "text-cream" : "text-navy"
      }`}
    >
      {title}
    </h2>
    <StripeBar className="h-1 w-28 mt-5 rounded-full overflow-hidden" />
  </Reveal>
);
